import { render, staticRenderFns } from "./ApprovalTable.vue?vue&type=template&id=21b488ea&scoped=true&"
import script from "./ApprovalTable.vue?vue&type=script&lang=js&"
export * from "./ApprovalTable.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalTable.vue?vue&type=style&index=0&id=21b488ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b488ea",
  null
  
)

export default component.exports